import { render } from "./TikTokSvg.vue?vue&type=template&id=09d14342"
import script from "./TikTokSvg.vue?vue&type=script&lang=js"
export * from "./TikTokSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__